import { clsx } from 'external/clsx'
import { useMemo, Link, useNavigate, FC } from 'external/react'
import usePackage from 'context/package-context/hook'
import { studentAssignmentWarning } from 'pages/home/packages/dialogs/StudentAssignmentWarning'
import { showConfirmDialog } from 'components/Notify'

type SavePackageButtonProps = {
    saveDisabled: boolean
}

const SavePackageButton: FC<SavePackageButtonProps> = (props) => {

    const {saveDisabled} = props
    const navigate = useNavigate()

	const {isAssigned, savePackage} = usePackage()

    const label = useMemo(() => isAssigned ? 'Guardar' : 'Asignar', [isAssigned])
    
    async function handleClick(e: { preventDefault: () => void }) {
        e.preventDefault()
        const successMessage = isAssigned ? 'Se actualizo el registro satisfactoriamente.' : 'Asignación realizada, recibirás en tu correo la información del paquete.'
        const isConfirmed = await (isAssigned ? Promise.resolve(true) : studentAssignmentWarning())
        if (!isConfirmed) return
        await savePackage()
        await showConfirmDialog(successMessage, {icon: 'success', showCancelButton: false})
        navigate('/home/packages')
    }

    return (
        <Link
            className={clsx('btn', 'btn-secondary', 'btn-lg', 'd-flex', 'justify-content-center', 'flex-column' , 'w-100', {disabled: saveDisabled})}
            style={{ height: '86px' }}
            onClick={handleClick} 
            to='/home/packages'
        >
            {label}
        </Link>
    )
}

export default SavePackageButton